export const EMBROIDERY_FONT = [
  {
    image: "/images/common/cart/alphanumeric-gothic.svg",
    value: "英数字ゴシック体",
  },
  {
    image: "/images/common/cart/alphanumeric-cursive.svg",
    value: "英数字筆記体",
  },
  {
    image: "/images/common/cart/hiragana-gothic.svg",
    value: "ひらがなゴシック体",
  },
]

export const EMBROIDERY_ALPHANUMERIC_CURSIVE_COLOR = [
  { image: "/images/common/cart/silver-cursive.svg", value: "シルバー" },
  { image: "/images/common/cart/white-cursive.svg", value: "ホワイト" },
  { image: "/images/common/cart/gold-cursive.svg", value: "ゴールド" },
  { image: "/images/common/cart/blue-cursive.svg", value: "ブルー" },
  { image: "/images/common/cart/pink-cursive.svg", value: "ピンク" },
  { image: "/images/common/cart/green-cursive.svg", value: "グリーン" },
]

export const EMBROIDERY_ALPHANUMERIC_GOTHIC_COLOR = [
  { image: "/images/common/cart/silver-gothic.svg", value: "シルバー" },
  { image: "/images/common/cart/white-gothic.svg", value: "ホワイト" },
  { image: "/images/common/cart/gold-gothic.svg", value: "ゴールド" },
  { image: "/images/common/cart/blue-gothic.svg", value: "ブルー" },
  { image: "/images/common/cart/pink-gothic.svg", value: "ピンク" },
  { image: "/images/common/cart/green-gothic.svg", value: "グリーン" },
]

export const EMBROIDERY_HIRAGANA_GOTHIC_COLOR = [
  { image: "/images/common/cart/silver-hiragana.svg", value: "シルバー" },
  { image: "/images/common/cart/white-hiragana.svg", value: "ホワイト" },
  { image: "/images/common/cart/gold-hiragana.svg", value: "ゴールド" },
  { image: "/images/common/cart/blue-hiragana.svg", value: "ブルー" },
  { image: "/images/common/cart/pink-hiragana.svg", value: "ピンク" },
  { image: "/images/common/cart/green-hiragana.svg", value: "グリーン" },
]
